import React from 'react';

interface TeddyBearProps {
  className?: string;
  size?: number;
}

export const TeddyBear: React.FC<TeddyBearProps> = ({ className = "", size = 24 }) => {
  return (
    <img
      src="/teddy.svg" 
      alt="Teddy Bear"
      width={size}
      height={size}
      className={className}
      style={{ backgroundColor: 'transparent' }}
    />
  );
};

export default TeddyBear;